<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36.426 16.563H22.845c-1.98 0-2.986.661-2.986.661l-10.486 7.88c-.067.06-.126.128-.176.202a1.872 1.872 0 0 0-.643 1.4c0 1.046.848 1.894 1.894 1.894.432 0 .806-.174 1.125-.42v.044l.613-.43c1.408-.91 7.116-4.604 7.603-4.887.557-.321 1.344-.278 1.944.555.694 1.39-1.064 2.407-1.064 2.407l-6.125 3.997c-1.197.78-2.254.936-2.78.963l-8.64.037c-.14 0-.271.008-.404.012h-.662c-.02 0-.036-.01-.055-.01-.653 0-1.2.354-1.536.862a1.821 1.821 0 0 0-.34 1.013c.001 1.035.84 1.875 1.876 1.875h14.143a7.396 7.396 0 0 0 3.808-1.175l9.307-6.133c.029-.019.89-.588 2.46-.598 1.171-.01 2.344-.006 3.516.011h.08c.075 0 .203-.005.352-.025h.755a1.872 1.872 0 0 0 1.872-1.872v-6.39a1.872 1.872 0 0 0-1.872-1.873h.002ZM.766 8.757s.02.109.07.299v.008c.318 1.24 1.916 6.12 8.188 10.427l.003.018.615.408.355-.234.003-.013c6.589-4.419 8.173-9.508 8.46-10.665v-.007c.038-.155.054-.243.054-.243l-.02-.005c.032-.29.07-.788-.035-1.225 0-.013-.012-.01-.016-.023a4.428 4.428 0 0 0-4.365-3.718 4.422 4.422 0 0 0-4.406 4.144h-.06a4.427 4.427 0 0 0-4.407-4.144A4.424 4.424 0 0 0 .81 7.764c-.019.012-.035.04-.045.097-.048.277-.016.633.021.89l-.02.006Z" fill="url(#paint0_linear_11_913)" />
    <defs>
      <linearGradient
        id="paint0_linear_11_913"
        x1=".128"
        y1="34.618"
        x2="38.296"
        y2="34.618"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F87900" />
        <stop offset=".511" stop-color="#FE4F45" />
        <stop offset="1" stop-color="#E419BA" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {}
</script>
